<template>
  <div class="package-type-container mx-10 md:ml-16 md:mr-32 mt-64 relative text-dcblue ">
    <div class="package-type-wrapper flex justify-end w-full absolute hidden md:flex">
        <div
            class="relative w-48 border-solid border border-packageborder rounded-lg px-4 pt-5 pb-0 text-center"
            v-for="(packageType, index) in packageTypes"
            v-bind:key="index"
            :class="index === packageTypes.length - 1 ? '' : 'mr-3'"
        >
            <ColourCircle class="absolute color-shadow" className="dot" :colour-code="packageType.colour"></ColourCircle>
            <div class="text-175 font-semibold">{{ packageType.type }}</div>
            <div class="package-desc text-xl font-futura">{{packageType.desc}}</div>
            <div
            class="h-16 flex justify-center"
            v-for="(term, index) in terms"
            v-bind:key="index">
            <img v-if="packageType.contents.indexOf(term.tid) > -1" class="self-center" src="@/assets/checkgreen.svg"/>
            </div>
        </div>
    </div> 
    <div class="w-full md:hidden absolute select-access items-center">
        <h3 class="text-center font-bold">Packages</h3>
        <div class="flex flex-row justify-between">
            <span :class="isActive === 'Bronze' ? 'active' : null" @click="isActive='Bronze'">
                BRONZE
            </span>
            <span :class="isActive === 'Silver' ? 'active' : null" @click="isActive='Silver'">
                SILVER
            </span>
            <span :class="isActive === 'Gold' ? 'active' : null" @click="isActive='Gold'">
                GOLD
            </span>
            <span :class="isActive === 'Ship' ? 'active' : null" @click="isActive='Ship'">
                SHIP
            </span>
        </div>
    </div>

    <div class="package-type-wrapper flex justify-end w-full absolute flex md:hidden">
        <PackageType :access="returnPackageType(isActive)" :terms="terms" />
    </div>

    <div class="pt-8 pb-0 pl-6 sm:pl-0 pr-0 sm:pr-6 h-16 uppercase font-semibold text-1035 tracking-widest">Contents</div>
    <div
      v-for="(term, index) in terms"
      v-bind:key="term.tid"
      :class="{ 'bg-white' : (index % 2) == false  }"
      class="py-4 px-6 h-16 font-semibold">
      <span class="align-middle">
        {{ term.name }}{{term.name === "IMO" ? '*' : null}}
        <router-link :to="{name: 'library', params: { library: term.name } }" class="library-link" mode="hash">
            <img src="@/assets/info.png" class="inline-block ml-2"/>
        </router-link>
      </span>
    </div>
    <div
      class="py-4 px-6 h-16 font-semibold bg-white flag-states"
      :class="`${isActive}-isActive`">
      <span class="align-middle mr-auto">
        Flag States
        <router-link :to="{name: 'library', params: { library: 'Flag States' } }" class="library-link" mode="hash">
            <img src="@/assets/info.png" class="inline-block ml-2"/>
        </router-link>
        
      </span>
      <div class="additional-material">
            <p>Additional material</p>
        </div>
        <div class="vessel-flags">
            <p>Vessel flag included</p>
        </div>
    </div>

    <br>
    <div class="flex flex-row justify-center">
        <p class="text-right">Other combinations are available on request</p>
    </div>
    <div class="w-full mt-8 md:hidden select-access items-center">
        <div class="flex flex-row justify-between">
            <span :class="isActive === 'Bronze' ? 'active' : null" @click="isActive='Bronze'">
                BRONZE
            </span>
            <span :class="isActive === 'Silver' ? 'active' : null" @click="isActive='Silver'">
                SILVER
            </span>
            <span :class="isActive === 'Gold' ? 'active' : null" @click="isActive='Gold'">
                GOLD
            </span>
            <span :class="isActive === 'Ship' ? 'active' : null" @click="isActive='Ship'">
                SHIP
            </span>
        </div>
    </div>
  </div>
</template>

<script>
    import ColourCircle from "@/components/ColourCircle";
    import PackageType from "./PackageType";

    export default {
        name: "Packages",
        components: {
            ColourCircle,
            PackageType
        },
        data: function () {
            return {
                terms: [],
                isActive: 'Bronze',
                packageTypes: []
            }
        },
        created() {

            let _self = this;

            // Make a request for a user with a given ID
            this.axios.get('/packages?_format=json')
                .then(function (response) {                    
                    response.data.forEach((data) => {
                        _self.packageTypes.push({
                            order: _self.returnOrder(data.title),
                            type: data.title,
                            desc: data.field_description,
                            colour: data.field_colour,
                            contents: _self.parseContentsTerms(data.field_contents)
                        })
                    });

                     _self.packageTypes.sort((a,b) => a.order - b.order);
                })
                .catch(function () {
                    // handle error
                });

            _self.axios.get('/package_contents?_format=json')
                .then(function (response) {
                    _self.terms = response.data;
                })
                .catch(function () {
                    // handle error
                });

        },
        methods: {
            parseContentsTerms(contentsTermsString) {
                let contentsTermIds = [];

                let contentTerms = contentsTermsString.split(',');

                contentTerms.forEach((termid) => {
                    contentsTermIds.push(termid.trim());
                });

                return contentsTermIds;
            },
            returnPackageType(activePackage) {
                return this.packageTypes.filter(i => i.type === activePackage)[0];
               
            },
            returnOrder(title) {
                switch (title) {
                    case "Bronze":
                        return 1;
                    case "Silver":
                        return 2
                    case "Gold":
                        return 3
                    case "Ship":
                        return 4;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

  .package-desc {
    padding-bottom: 20px;
    height: 200px;
    overflow: hidden;
  }

  .package-type-wrapper {
    top: -200px;
    pointer-events: none;
  }

  .color-shadow {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.23);
  }

  .library-link {
      pointer-events: all;
  }

  .select-access {
      top: -345px;

      h3 {
          font-size: 1.75em;
          margin-bottom: 15px;
      }

      p {
          padding-right: 15px;

      }



      span {

          &.active {
              border-bottom: 3px solid green;
          }
      }

  }

  @media (max-width: 600px) {
      .package-type-container {
          margin-top: 22em;
      }
  }

  .flag-states {
      display: flex;
      padding-right: 0;
      padding-bottom: 0;
      height: auto;
      align-items: center;
  }

  .additional-material,
  .vessel-flags {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #CCC;
      border-radius: 0.5rem;
      padding: 1rem 0;
  }

  .additional-material {
      width: 37.5rem;
  }

  .vessel-flags {
      width: 12rem;
      margin-left: 0.75rem;
  }

  @media (max-width: 691px) {
      .flag-states {
          border-left: 1px solid #CCC;
          border-right: 1px solid #CCC;
          border-bottom: 1px solid #CCC;
          border-bottom-right-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
          .additional-material,
          .vessel-flags {
              border: none;
              width: 12rem;
              margin-left: auto;
          }

          &.Bronze-isActive,
          &.Silver-isActive,
          &.Gold-isActive {
              .vessel-flags {
                  display: none;
              }
          }

          &.Ship-isActive {
              .additional-material {
                  display: none;
              }
          }
      }
  }

</style>
